import { createSlice } from '@reduxjs/toolkit';

// utils
import axios from 'utils/axios';
import { validateDates } from 'utils/formatTime';
import { ACTIONS } from 'utils/constants';

//
import API from 'restApi';
import { dispatch, store } from '../store';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  users: [],
  user: null,
  account: null,
  preferences: null,
  navig: {
    total: 0,
    nav_position: 0,
    nb_item_per_page: 10
  },
  filters: {
    name: "",
    firstname: "",
    logincode: "",
    profilecode: "",
    actors: [],
    status: { label: 'Actif', code: 'A' },
    lastUpdateFrom: null,
    lastUpdateTo: null,
    sort_column_name: 'name',
    sort_type: 'ASC'
  },
};

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      //  state.users = [];
      //  state.navig = initialState.navig;

    },
    // GET User
    getUserSuccess(state, action) {
      const { user } = action.payload;
      state.isLoading = false;
      state.user = user;
      state.error = null;

    },
    getAccountSuccess(state, action) {
      const { account } = action.payload;
      state.isLoading = false;
      state.account = account;
      state.error = null;
    },
    getPreferencesSuccess(state, action) {
      const { preferences } = action.payload;
      state.isLoading = false;
      state.preferences = preferences;
      state.error = null;
    },
    resetUser(state) {
      state.user = initialState.user;

    },

    // GET Users
    getUsersSuccess(state, action) {
      const { users, navig } = action.payload;
      state.isLoading = false;
      state.users = users;
      state.navig = navig;
      state.error = null;

    },

    //  SORT & FILTER Users
    sortByUsers(state, action) {
      state.sortBy = action.payload;
    },
    //   pagination Users
    paginationUsers(state, action) {
      state.navig = { ...state.navig, nav_position: action.payload };
    },
    sortUsers(state, action) {
      state.filters = { ...state.filters, sort_type: action.payload.orderColumn, sort_column_name: action.payload.sortColumn };
    },
    filterUsers(state, action) {
      state.filters = action.payload;
    },
    resetUsers(state) {
      state.users = initialState.users;
      state.navig = initialState.navig;
      state.filters = initialState.filters;
    }

  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  sortByUsers,
  paginationUsers,
  filterUsers,
  resetUsers,
  resetUser,
  hasError,
  sortUsers
} = slice.actions;

// ----------------------------------------------------------------------

export function getUsers() {
  const { user: { filters, navig }, all: { config } } = store.getState();
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const start = new Date(filters.lastUpdateFrom).getTime();
      const end = new Date(filters.lastUpdateTo).getTime();
      const errors = validateDates({ start, end });
      if (Object.keys(errors).length > 0)
        throw new Error('', { cause: [errors] });

      // Fixer lastUpdateTo à 23h59
      const lastUpdateTo = filters.lastUpdateTo ? new Date(new Date(filters.lastUpdateTo).setHours(23, 59, 59)).toISOString() : null;

      const criteres = {
        ...filters,
        profilecode: filters.profilecode?.code,
        status: filters.status?.code,
        actors: filters.actors.map((item) => item?.actorCode),
        lastUpdateTo
      };

      const response = await axios.post(API.path, {
        criteres,
        navig: {
          total: navig.total,
          nav_position: navig.nav_position,
          nb_item_per_page: config?.nbItemPerPage
        },
        action: ACTIONS.SEARCHUSER
      });

      const { data } = response;
      dispatch(slice.actions.getUsersSuccess(data));
      if (data.users.length === 0)
        throw new Error('NO_RESULTS');

    } catch (error) {
      dispatch(slice.actions.hasError(error?.cause?.length > 0 ? error.cause[0] : error));
    }
  };
}


export function getUser({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADUSER,
        staffcode: code
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getUserSuccess({ user: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getAccount({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADACCOUNT,
        code
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getAccountSuccess({ account: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}


export function getPreferences({ code }) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await axios.post(API.path, {
        action: ACTIONS.LOADUSERPREF,
        userCode: code
      });

      const { data: { data } } = response;
      dispatch(slice.actions.getPreferencesSuccess({ preferences: data }));

    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function testLoginIsValid(logincode) {
  const { data: { isValid } } = await axios.post(API.path, {
    action: ACTIONS.ISLOGINVALID,
    logincode
  });
  return isValid;
}
export async function testPasswordIsValid({ staffcode, password, nbHistoDiffPassword }) {
  const { data: { isValid } } = await axios.post(API.path, {
    action: ACTIONS.ISPASSWORDVALID,
    staffcode,
    password,
    nb_histo_diff_password: nbHistoDiffPassword
  });
  return isValid;
}


export async function getUniqueFilters({ userCode, actorsSelected, allFavoriteActorsSelected, allActorsSelected }) {
  const { data: { examFilters } } = await axios.post(API.path,
    {
      action: ACTIONS.ALLFILTERSFORUSER,
      criteres: {
        userCode,
        allFavoriteActorsSelected,
        allActorsSelected,
        actorsSelected: actorsSelected.map((item) => item.actorCode)

      }
    }
  );
  return examFilters;
}

